import React from 'react';
import NotFind from '../components/customLayout/notfind';
const AnnualReportsPage: React.FC = () => {
  return (
    <div className="bg-white border rounded-md p-4 mx-5">
      <div className="font-medium text-lg mb-4">Jahresmeldungen</div>
      <div className="py-10">
        <NotFind />
      </div>
    </div>
  );
};

export default AnnualReportsPage;
